import Vue from "vue";
import { paradaService } from "@/_services";

export function enviosParadaState() {
  return { enviosPorParada: {}, enviosVersion: 0 };
}

function currentRequest(state, request) {
  const entry = state.enviosPorParada[request.id];
  return entry && state.enviosVersion === request.version && entry.requestId === request.requestId;
}

export const enviosParadaMutations = {
  resetEnviosParadas(state) {
    state.enviosVersion += 1;
    state.enviosPorParada = {};
  },
  enviosParadaRequest(state, request) {
    const previous = state.enviosPorParada[request.id];
    Vue.set(state.enviosPorParada, request.id, {
      data: null, total: previous ? previous.total : 0, page: request.page,
      requestId: request.requestId, status: { loading: true },
    });
  },
  enviosParadaSuccess(state, { request, data }) {
    if (!currentRequest(state, request)) return;
    const entry = state.enviosPorParada[request.id];
    entry.data = data;
    entry.total = data.total || 0;
    entry.status = { loaded: true };
  },
  enviosParadaError(state, { request, error }) {
    if (!currentRequest(state, request)) return;
    const entry = state.enviosPorParada[request.id];
    entry.data = null;
    entry.status = { error };
  },
};

export const enviosParadaActions = {
  resetEnviosParadas({ commit }) {
    commit("resetEnviosParadas");
  },
  getEnviosByParada({ state, commit }, { id, page = 1 }) {
    const entry = state.enviosPorParada[id];
    if (entry && (entry.status.loading || (entry.status.loaded && entry.page === page))) return;
    const request = { id, page, version: state.enviosVersion, requestId: entry ? entry.requestId + 1 : 1 };
    commit("enviosParadaRequest", request);
    return paradaService.getEnviosByParada(id, { currentPage: page, perPage: 5 })
      .then((data) => commit("enviosParadaSuccess", { request, data }))
      .catch((error) => commit("enviosParadaError", { request, error }));
  },
};
